import React from 'react';
import Grid, { GridSize } from '@material-ui/core/Grid';

export interface MultiColumnsProps {
  elements: JSX.Element[];
  xs?: GridSize[];
  md?: GridSize[];
  xl?: GridSize[];
}

function getGridSizes(sizes?: GridSize[], elementsNo: number = 1): GridSize[] {
  if (sizes) {
    return [...Array(elementsNo)].map((v, i) => sizes[i] ?? 12);
  }
  return [...Array(elementsNo)].map(() => (12 / (elementsNo !== 0 ? elementsNo : 1)) as GridSize);
}

const MultiColumns: React.FC<React.PropsWithChildren<MultiColumnsProps>> = ({ elements, md, xl, xs }) => {
  const elementsNo = elements.length;
  const xsWidth = getGridSizes(xs, elementsNo);
  const mdWidth = getGridSizes(md, elementsNo);
  const xlWidth = xl ? getGridSizes(xl, elementsNo) : [...Array(elementsNo)];
  return (
    <Grid container spacing={1} xs={12} item style={{ maxWidth: 'calc(100% + 4px)' }}>
      {elements.map((el, i) => (
        <Grid item xs={xsWidth[i] as any} md={mdWidth[i] as any} xl={xlWidth[i]} key={i}>
          {el}
        </Grid>
      ))}
    </Grid>
  );
};

export default MultiColumns;
